// extracted by mini-css-extract-plugin
export default {"section":"_1DTk0SB22pV1jD4AwAMr","summary":"xPHJP_RrpG1WyBlX_G0U","delivery-type":"HlJlxqky8VcRf7qqxvdY"};